import type { GetCoveredProps } from '@/components/renters/GetCovered';
import type { HeroProps } from '@/components/renters/Hero';
import type { ProtectedProps } from '@/components/renters/Protected';
import type { CustomersReviewsProps } from '@/components/shared';
import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/assets/renters/og.png';
import type { BasePageConfig } from '../../BasePageConfig';

const productJsonld = {
  '@context': 'https://schema.org/',
  '@type': 'Product',
  name: 'Lemonade Dating Insurance',
  description: 'Lemonade dating insurance protects your wallet from your heart',
  image: [ogImage],
  brand: {
    '@type': 'Brand',
    name: 'Lemonade',
    logo: 'https://www.lemonade.com/assets/logo-e0f7c4f109ef5af2bb9604137856587ca61a56ed8c3ab2b8f56fcec923babafc.svg',
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.9',
    ratingCount: '62818',
  },
  offers: {
    '@type': 'AggregateOffer',
    offerCount: '',
    lowPrice: '5',
    highPrice: '',
    priceCurrency: 'USD',
  },
};
export interface Config extends BasePageConfig {
  hero: HeroProps;
  customersReviews: CustomersReviewsProps;
  protected: ProtectedProps;
  video: Pick<GetCoveredProps, 'title' | 'subtitle'>;
  bottomCta: HeroProps;
}

export const config: Config = {
  layout: { ...sharedConfig['en-US'].layout },
  seo: {
    title: 'Dating - Quotes Starting at $30/mo | Lemonade',
    metaTitle: 'Dating - Quotes Starting at $30/mo | Lemonade',
    description:
      'Lemonade dating insurance protects your wallet from your heart. Bad date? File a claim and get paid. No hassle. No ghosting. Not from us, anyway. Starting from $30/month.',
    ogImage: ogImage.src,
    jsonld: [productJsonld],
    noIndex: true,
  },
  hero: {
    title: 'bad dates shouldn’t \ncost you Money',
    subtitle: "You're already paying emotionally.",
    ctaLabel: 'Learn More',
    trackingLabel: 'dating_hero',
  },
  customersReviews: {
    title: 'The (almost) 5-star insurance company',
    subtitle:
      'Lemonade has earned 4.9 stars in the App Store and on Google Play, and is\nalso top-rated by Supermoney, Clearsurance, and single people everywhere.',
  },
  protected: {
    title: 'Protect your wallet from your heart',
    subtitle: 'Focus on finding love. Not finding money to pay for dates.',
  },
  video: {
    title: 'Bad date? Find someone better.',
    subtitle: 'File a claim and get paid. No hassle. No ghosting. Not from us, anyway.',
  },
  bottomCta: {
    title: 'Sound too good to be true?',
    subtitle: "*For Renters, Pet, Car Insurance, and more. When it comes to dating, you're on your own.",
    ctaLabel: 'Check our prices*',
    ctaUrl: 'https://www.lemonade.com',
  },
};
